@if (view === 'view') {
	<pk-broker-pricing-session-supplier-notes-view
		[rfqSessionSuppliers]="rfqSessionSuppliers"
		(editNote)="editNote($event)"></pk-broker-pricing-session-supplier-notes-view>
} @else {
	<pk-broker-pricing-session-supplier-notes-add-edit
		[rfqSessionSupplier]="editRfqSessionSupplier"
		[editNoteKey]="editNoteKey"
		(backToNotes)="backToNotes()"></pk-broker-pricing-session-supplier-notes-add-edit>
}
